export const getRovoChatProduct = (): string => {
	let product = 'UNKNOWN';
	const win = window as Window & { __ROVO_CHAT_CONFIG_PRODUCT__?: string };
	if (win.__ROVO_CHAT_CONFIG_PRODUCT__) {
		product = win.__ROVO_CHAT_CONFIG_PRODUCT__;
	}
	return product;
};
